/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";

const Line = styled.div({
  backgroundColor: "#333333",
  borderRadius: "2px",
  width: "3rem",
  height: "2px",
  position: "relative",
});

const Circle = styled.div(
  {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    border: "2px solid #333333",
    backgroundColor: "#ffffff",
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "50%",
    transition: "all 0.25s ease-in-out",
  },
  (props) => ({
    left: props.left || "7px",
  })
);

const LineContainer = styled.div({
  position: "relative",
});

function FilterIcon({ open }) {
  return (
    <div
      css={{
        padding: "6px 0",
        height: "3rem",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
      }}
    >
      <LineContainer>
        <Line />
        <Circle left={open ? "7px" : "calc(100% - 7px)"} />
      </LineContainer>
      <LineContainer>
        <Line />
        <Circle left={open ? "calc(100% - 7px)" : "7px"} />
      </LineContainer>
    </div>
  );
}

export default FilterIcon;
